import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DialogTriggerDirective } from '../../directives/dialog-trigger.directive';
import { ClaimRow } from '../../models/api/view/claim-view/claim-row';
import { Action } from '../../models/core/action';
import { Session } from '../../services/session/session.service';
import { ViewService } from '../../services/view/view.service';
import { ExpandButtonComponent } from '../core/buttons/expand-button.component';
import { IconComponent } from '../core/labels/icon.component';
import { TagComponent } from '../core/labels/tag.component';
import { DialogComponent } from '../core/panels/dialog.component';
import { FieldSearchComponent } from '../view/field-search/field-search.component';

@Component({
  selector: 'app-sidenav',
  imports: [
    BadgeModule,
    OverlayBadgeModule,
    RouterModule,
    CommonModule,
    SelectButtonModule,
    IconComponent,
    ReactiveFormsModule,
    DialogComponent,
    FieldSearchComponent,
    TagComponent,
    ExpandButtonComponent,
    DialogTriggerDirective,
  ],
  template: `
    <div class="tw-w-[230px]">
      <div
        class=" tw-pb-16 tw-pt-4 tw-pl-2  tw-bg-[var(--sed-open-grey-color)] tw-min-h-[600px]"
      >
        <div class="tw-flex-col tw-items-center">
          @for (item of items; track item) {
            <div
              class="tw-flex tw-py-1 text-color tw-items-center "
              [ngClass]="{
                'tw-block md:tw-hidden':
                  item.key !== 'view' &&
                  item.key !== 'announcements' &&
                  item.key !== 'watchlist' &&
                  item.key !== 'search' &&
                  item.key !== 'history',
              }"
            >
              <app-icon
                [name]="item.icon"
                color="var(--sed-black-60-color)"
                class="tw-p-0.5"
                size="1.2rem"
              />

              <a
                class="tw-text-[15px] tw-font-bold tw-pl-3 hover:tw-underline tw-decoration-2"
                [routerLink]="item.routerLink"
                routerLinkActive="tw-underline"
                [routerLinkActiveOptions]="{ exact: true }"
                [innerHTML]="item.label"
              ></a>
              @if (item.badge) {
                <app-tag class="tw-pl-2" type="Green">{{ item.badge }}</app-tag>
              }
            </div>

            @if (item.key === 'view' && viewService.currentClaim()) {
              <!--claim group-->
              @for (ci of claimItems; track ci) {
                <div class=" tw-pr-4">
                  <div
                    class="tw-border-l
              tw-flex
              tw-items-center
              tw-pb-1.5
              tw-ml-2
              tw-border-[var(--sed-grey-100-color)]
              tw-text-[13px]
              tw-pl-3
              tw-pt-2
              tw-uppercase
              tw-font-bold
              tw-text-[var(--sed-black-80-color)]"
                  >
                    @if (ci.key === 'details') {
                      <div>
                        <div class="tw-pt-2 tw-pr-1">
                          {{ currentClaim.claimantFirstName }}
                          {{ currentClaim.claimantLastName }}
                        </div>
                        <div class="tw-pb-1">{{ currentClaim.fileNumber }}</div>
                      </div>
                      <div class="tw-grow"></div>

                      <app-icon
                        name="fa-glasses"
                        size="1.2rem"
                        appDialogTrigger
                        (click)="fieldDialog.visible = true"
                        class="tw-cursor-pointer tw-pr-3"
                      ></app-icon>
                    } @else {
                      <span [innerHTML]="ci.label"></span>
                      <div class="tw-grow"></div>
                    }

                    <app-expand-button
                      [expanded]="ci.data.expanded"
                      [label]="ci.label"
                      size="1.2rem"
                      (expand)="ci.data.expanded = $event"
                    />
                  </div>
                </div>
                @if (ci.data.expanded) {
                  <!-- claim page -->
                  @for (page of ci.items; track page) {
                    <div class="tw-flex tw-items-center tw-pr-4">
                      <a
                        class="tw-border-l tw-pb-1.5 tw-ml-2 tw-border-[var(--sed-grey-100-color)] tw-text-[13px] tw-pl-6 hover:tw-underline tw-decoration-2"
                        [routerLink]="page.routerLink"
                        routerLinkActive="tab-active tw-underline tw-decoration-2"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="
                          viewService.navigateCurrentClaim(page.routerLink)
                        "
                        [innerHTML]="page.label"
                      >
                      </a>
                    </div>
                  }
                }
              }
            }
          }
        </div>
      </div>
    </div>
    <app-dialog #fieldDialog label="Search Claim Fields" width="550px">
      <ng-template #content>
        <app-field-search
          (navigate)="navigateCLaimField(fieldDialog, $event)"
        ></app-field-search
      ></ng-template>
    </app-dialog>
  `,
  styles: ``,
})
export class SidenavComponent implements OnInit {
  protected viewService = inject(ViewService);
  private session = inject(Session);

  options: any[] = [
    { label: 'Full', value: 'full' },
    { label: 'basic', value: 'basic' },
  ];

  items: Action[] = [
    { label: 'Home', icon: 'fa-home', routerLink: '' },
    {
      label: 'Dashboards',
      icon: 'fa-chart-pie',
      routerLink: '/dashboards',
    },
    {
      label: 'Claim Search',
      icon: 'fa-search',
      routerLink: '/view/search',
      key: 'search',
    },
    {
      label: 'History',
      icon: 'fa-history',
      routerLink: '/view/history',
      key: 'history',
    },
    {
      label: 'Watchlist',
      icon: 'fa-star',
      routerLink: '/view/watchlist',
      key: 'watchlist',
    },
    {
      label: 'View',
      icon: 'fa-user fa-light',
      routerLink: '/view',
      key: 'view',
    },
    {
      label: 'My to-do',
      icon: 'fa-calendar fa-light',
      routerLink: '/todo',
    },
    {
      label: 'Reports',
      icon: 'fa-file fa-light',
      routerLink: '/reports',
      key: 'reports',
    },
    {
      label: 'Query',
      icon: 'fa-magnifying-glass-chart',
      routerLink: '/query',
      key: 'query',
    },
    {
      label: 'Alerts',
      icon: 'fa-bell fa-light',
      routerLink: '/alerts',
      key: 'alerts',
    },
    {
      label: 'Applications',
      icon: 'fa-arrow-up-right-from-square',
      routerLink: '/applications',
    },
    { label: 'Preferences', icon: 'fa-gear', routerLink: '/preferences' },
    {
      label: 'Design',
      icon: 'fa-palette',
      routerLink: '/design',
      key: 'design',
    },
    {
      label: 'QA Tools',
      icon: 'fa-wrench',
      routerLink: '/qa-tools',
      key: 'qatools',
    },
    {
      label: 'Downloads',
      icon: 'fa-download fa-light',
      routerLink: '/downloads',
      key: 'downloads',
    },
    {
      label: 'My Diary',
      icon: 'fa-book fa-light',
      routerLink: '/mydiary',
      key: 'mydiary',
    },
  ];

  claimItems: Action[];

  get currentClaim(): ClaimRow {
    return this.viewService.currentClaim();
  }

  ngOnInit(): void {
    // TODO: rather than claim items array, embed claim-menu component and make it responsive stacked layout for side nav.
    this.claimItems = [];

    // Filter items based on security and QA mode
    this.items = this.items.filter((item) => {
      if (item.key === 'qatools' || item.key === 'design') {
        return this.session.user?.qaTools ?? false;
      }
      if (item.key === 'alerts') {
        return this.session.authorize('AlertsModule');
      }
      if (item.key === 'reports') {
        return (
          this.session.authorize('ReportsModule') ||
          this.session.authorize('FiltersModule')
        );
      }
      if (item.key === 'query') {
        return this.session.authorize('Query');
      }
      return true;
    });
  }

  protected navigateCLaimField(dialog: DialogComponent, routerLink: string) {
    dialog.visible = false;
    this.viewService.navigateCurrentClaim(routerLink);
  }

  protected navigateClaim(item: Action) {
    this.viewService.navigateCurrentClaim(item.routerLink as string);
  }
}
